export default "__VITE_ASSET__KcPmQ2eQ__"